import React, {Component} from 'react';
import PropTypes from "prop-types";
import {AmountInput} from "./amountInput";
import {Translate} from "app/services/translate";
import {CountrySelect} from "./countrySelect";
import {CurrencySelect} from "./currencySelect";
import {Arrow} from "./arrow";

export class Amounts extends Component {
    static get propTypes() {
        return {
            settings: PropTypes.object,
            countryIn: PropTypes.string,
            countryOut: PropTypes.string,
            availableCountriesIn: PropTypes.array,
            availableCountriesOut: PropTypes.array,
            availableCurrenciesIn: PropTypes.array,
            availableCurrenciesOut: PropTypes.array,
            amountIn: PropTypes.object,
            amountOut: PropTypes.object,
            onCountryChange: PropTypes.func,
            onAmountChange: PropTypes.func,
            onCurrencyChange: PropTypes.func,
        }
    }

    constructor(props) {
        super(props);
        this.translates = {
            countryIn: `${Translate('calculator_sender_country')}:`,
            countryOut: `${Translate('calculator_recipient_country')}:`,
            amountIn: `${Translate('calculator_amount')}:`,
            amountOut: `${Translate('calculator_amount')}:`,
        };

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleCurrencyChange = this.handleCurrencyChange.bind(this);
    }

    handleCountryChange(country, type) {
        this.props.onCountryChange(country, type);
    }

    handleAmountChange(type, amount) {
        this.props.onAmountChange(type, amount);
    }

    handleCurrencyChange(currency, type) {
        this.props.onCurrencyChange(currency, type);
    }

    render() {
        const {
            settings,
            countryIn,
            countryOut,
            availableCountriesIn,
            availableCountriesOut,
            amountIn,
            amountOut,
            availableCurrenciesIn,
            availableCurrenciesOut,
        } = this.props;
        const {disableCountries} = settings;
        const directions = availableCountriesIn && availableCurrenciesOut;
        return (
            <>
                {!disableCountries && directions &&
                <div className="countryIn">
                    <CountrySelect
                        settings={settings}
                        type="countryIn"
                        label={this.translates.countryIn}
                        value={countryIn}
                        countries={availableCountriesIn}
                        onChange={this.handleCountryChange}/>
                </div>
                }
                <div className="amounts amountsIn">
                    {!disableCountries && <label>{this.translates.amountIn}</label>}
                    <div className="input-with-select">
                        <div className={'amountIn'}>
                            <AmountInput
                                type="amountIn"
                                value={amountIn.getAmount}
                                onChange={this.handleAmountChange}/>
                        </div>
                        {availableCurrenciesIn &&
                        <div className="currencyIn">
                            <CurrencySelect
                                type="currencyIn"
                                value={amountIn.getCurrency}
                                currencies={availableCurrenciesIn}
                                onChange={this.handleCurrencyChange}/>
                        </div>
                        }
                    </div>
                </div>
                <div className="arrow">
                    <Arrow/>
                </div>
                {!disableCountries && directions &&
                <div className={'countryOut'}>
                    <CountrySelect
                        settings={settings}
                        type="countryOut"
                        label={this.translates.countryOut}
                        value={countryOut}
                        countries={availableCountriesOut}
                        onChange={this.handleCountryChange}/>
                </div>
                }
                <div className="amounts amountsOut">
                    {!disableCountries && <label>{this.translates.amountOut}</label>}
                    <div className="input-with-select">
                        <div className={'amountOut'}>
                            <AmountInput
                                type="amountOut"
                                value={amountOut.getAmount}
                                onChange={this.handleAmountChange}/>
                        </div>
                        {availableCurrenciesOut &&
                        <div className="currencyOut">
                            <CurrencySelect
                                type="currencyOut"
                                value={amountOut.getCurrency}
                                currencies={availableCurrenciesOut}
                                onChange={this.handleCurrencyChange}/>
                        </div>
                        }
                    </div>
                </div>
            </>
        )
    }
}
